import { FIELD_TYPES } from '../../../constants/fieldTypes';
import { validateAdditionalRoles } from '../../../utility/roles';

export const ADDITIONAL_ROLES_FIELD = [
  {
    name: 'additionalRoles',
    type: FIELD_TYPES.ADD_ADDITIONAL_ROLES_FIELD,
    shouldRemoveFieldSpacing: true,
    shouldRemoveFieldError: true,
    validators: [
      {
        validator: additionalRoles => validateAdditionalRoles(additionalRoles),
        isMultiple: true,
      },
    ],
  },
];

export const prepareAdditionalRolesInitialData = (roles = []) => {
  return { additionalRoles: roles.filter(role => !role?.is_system) };
};
